function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9297_29107)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M13.125 6H4.875M6 9.375C6 9.58211 5.83211 9.75 5.625 9.75C5.41789 9.75 5.25 9.58211 5.25 9.375M6 9.375C6 9.16789 5.83211 9 5.625 9C5.41789 9 5.25 9.16789 5.25 9.375M6 9.375H5.25M6 12.375C6 12.5821 5.83211 12.75 5.625 12.75C5.41789 12.75 5.25 12.5821 5.25 12.375M6 12.375C6 12.1679 5.83211 12 5.625 12C5.41789 12 5.25 12.1679 5.25 12.375M6 12.375H5.25M9.375 9.375C9.375 9.58211 9.20711 9.75 9 9.75C8.79289 9.75 8.625 9.58211 8.625 9.375M9.375 9.375C9.375 9.16789 9.20711 9 9 9C8.79289 9 8.625 9.16789 8.625 9.375M9.375 9.375H8.625M9.375 12.375C9.375 12.5821 9.20711 12.75 9 12.75C8.79289 12.75 8.625 12.5821 8.625 12.375M9.375 12.375C9.375 12.1679 9.20711 12 9 12C8.79289 12 8.625 12.1679 8.625 12.375M9.375 12.375H8.625M12.75 9.375C12.75 9.58211 12.5821 9.75 12.375 9.75C12.1679 9.75 12 9.58211 12 9.375M12.75 9.375C12.75 9.16789 12.5821 9 12.375 9C12.1679 9 12 9.16789 12 9.375M12.75 9.375H12M12.75 12.375C12.75 12.5821 12.5821 12.75 12.375 12.75C12.1679 12.75 12 12.5821 12 12.375M12.75 12.375C12.75 12.1679 12.5821 12 12.375 12C12.1679 12 12 12.1679 12 12.375M12.75 12.375H12",
  stroke: "#1B1C1C",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 0.75V3M12 0.75V3M6.3 16.5H11.7C13.3802 16.5 14.2202 16.5 14.862 16.173C15.4265 15.8854 15.8854 15.4265 16.173 14.862C16.5 14.2202 16.5 13.3802 16.5 11.7V6.3C16.5 4.61984 16.5 3.77976 16.173 3.13803C15.8854 2.57354 15.4265 2.1146 14.862 1.82698C14.2202 1.5 13.3802 1.5 11.7 1.5H6.3C4.61984 1.5 3.77976 1.5 3.13803 1.82698C2.57354 2.1146 2.1146 2.57354 1.82698 3.13803C1.5 3.77976 1.5 4.61984 1.5 6.3V11.7C1.5 13.3802 1.5 14.2202 1.82698 14.862C2.1146 15.4265 2.57354 15.8854 3.13803 16.173C3.77976 16.5 4.61984 16.5 6.3 16.5Z",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9297_29107"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

function SvgIcCalendarDatesHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarDatesHome);
export default __webpack_public_path__ + "static/media/ic_calendar-dates_home.690ebd2a.svg";
export { ForwardRef as ReactComponent };